var _defs, _rect, _path, _rect2, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPictographFullSmileLineEyesCyanWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7fb0f6;}.cls-1,.cls-2{stroke-width:0px;}.cls-2{fill:#fff;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 42.17,
    y: 48.68,
    width: 159.86,
    height: 159.86,
    transform: "translate(244.19 257.21) rotate(-180)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m126.67,217.13c-3.94,0-7.95-.37-11.97-1.13-32.94-6.25-54.92-36.71-49.01-67.89l9.82,1.86c-4.89,25.77,13.52,50.98,41.05,56.2,3.4.64,6.78.96,10.11.96,23.6,0,44.39-15.63,48.67-38.21l9.82,1.86c-5.19,27.37-30.19,46.35-58.5,46.35Z"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 74.03,
    y: 42.69,
    width: 10,
    height: 99.77,
    transform: "translate(-14.19 170.84) rotate(-89.53)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m201.4,122.63c-.11,0-.22,0-.34,0-10.68-.09-20.69-4.33-28.18-11.94s-11.57-17.69-11.48-28.37l10,.08c-.07,8.01,2.99,15.57,8.61,21.28,5.62,5.71,13.12,8.89,21.13,8.96.08,0,.17,0,.25,0,16.42,0,29.85-13.29,29.98-29.74l10,.08c-.09,10.68-4.33,20.69-11.94,28.18-7.53,7.41-17.48,11.48-28.03,11.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPictographFullSmileLineEyesCyanWhite);
export default __webpack_public_path__ + "static/media/pictograph-fullSmile-lineEyes-cyan-white.ef9e834b32c83db330adea54adfbce39.svg";
export { ForwardRef as ReactComponent };